import { addDays, startOfDay, startOfWeek, endOfWeek, startOfMonth, endOfMonth, subWeeks, subMonths } from 'date-fns'
import { enGB } from 'date-fns/locale'

const mondayWeekStart = { weekStartsOn: 1 as 1, locale: enGB }

const PREFIX = 'date-pref-'

export function savePref(pageKey: string, label: string) {
    localStorage.setItem(PREFIX + pageKey, label)
}

export function loadPref(pageKey: string): string | null {
    return localStorage.getItem(PREFIX + pageKey)
}

export function resolveLabel(label: string | null): { startDate: Date; endDate: Date } | null {
    if (!label) return null

    const today = startOfDay(new Date())

    switch (label) {
        case 'Today':
            return { startDate: today, endDate: today }
        case 'Yesterday': {
            const yesterday = addDays(today, -1)
            return { startDate: yesterday, endDate: yesterday }
        }
        case 'This Week':
            return {
                startDate: startOfWeek(today, mondayWeekStart),
                endDate: endOfWeek(today, mondayWeekStart)
            }
        case 'Last Week': {
            const lastWeek = subWeeks(today, 1)
            return {
                startDate: startOfWeek(lastWeek, mondayWeekStart),
                endDate: endOfWeek(lastWeek, mondayWeekStart)
            }
        }
        case 'This Month':
            return { startDate: startOfMonth(today), endDate: endOfMonth(today) }
        case 'Last Month': {
            const lastMonth = subMonths(today, 1)
            return { startDate: startOfMonth(lastMonth), endDate: endOfMonth(lastMonth) }
        }
        case 'Last 7 Days':
            return { startDate: addDays(today, -7), endDate: addDays(today, -1) }
        case 'Last 14 Days':
            return { startDate: addDays(today, -14), endDate: addDays(today, -1) }
        case '30 Days':
            return { startDate: addDays(today, -30), endDate: addDays(today, -1) }
        case '60 Days':
            return { startDate: addDays(today, -60), endDate: addDays(today, -1) }
        case '90 Days':
            return { startDate: addDays(today, -90), endDate: addDays(today, -1) }
        default:
            return null
    }
}
